"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JwtTokenHelper = void 0;
var JwtTokenHelper = /** @class */ (function () {
    function JwtTokenHelper() {
    }
    JwtTokenHelper.getInfo = function (token) {
        var jsonToken = JwtTokenHelper.parseToken(token);
        return {
            roles: jsonToken.roles || [],
            email: jsonToken.email,
            expiresOn: jsonToken.exp,
            issuedAt: jsonToken.iat,
            notValidBefore: jsonToken.nbf,
            appId: jsonToken.appid,
            uniqueName: jsonToken.unitque_name
        };
    };
    JwtTokenHelper.parseToken = function (token) {
        try {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            return JSON.parse(jsonPayload);
        }
        catch (e) {
            console.error('JwtTokenHelper: can not parse token');
            return {};
        }
    };
    return JwtTokenHelper;
}());
exports.JwtTokenHelper = JwtTokenHelper;
